










import { Component, Vue } from 'vue-property-decorator'
import store from '@/store'

@Component
export default class Avatar extends Vue {
  get username () {
    return store.state.user.authenticatedUser!.firstName.slice(0, 1) + store.state.user.authenticatedUser!.lastName.slice(0, 1)
  }
}

